export const AutomaticInteractionStatus = Object.freeze({
  DRAFT: 1,
  PENDING: 2,
  WAITING_FOR_APPROVAL: 3,
  APPROVED: 4,
  REJECTED: 5,
  DELETED: 99,
});
